module.exports = __webpack_public_path__ + "media/svg-new/key 1-96ccb4b4.svg";